// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fiat-activity-hero {
  min-height: auto;
  padding: 64px 0 40px;
}

.fiat-activity-actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-top: 28px;
  max-width: 560px;
}

.fiat-activity-action {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 16px 18px;
  border-radius: 12px;
  border: 1px solid rgba(209, 170, 103, 0.35);
  background: rgba(20, 24, 31, 0.55);
  color: #eaecef;
  text-decoration: none;
  transition: border-color 0.2s ease, transform 0.2s ease;
}

.fiat-activity-action:hover {
  border-color: #d1aa67;
  transform: translateY(-2px);
  color: #eaecef;
}

.fiat-activity-action-label {
  font-weight: 600;
  font-size: 15px;
}

.fiat-activity-action-hint {
  font-size: 12px;
  color: #84888c;
}

.fiat-activity-chip {
  appearance: none;
  border: 1px solid rgba(148, 163, 184, 0.35);
  background: transparent;
  color: #eaecef;
  border-radius: 999px;
  padding: 6px 14px;
  font-size: 13px;
  cursor: pointer;
}

.fiat-activity-chip.is-active {
  border-color: #d1aa67;
  color: #d1aa67;
}

.fiat-activity-desktop .df-deposit-history-head,
.fiat-activity-desktop .df-deposit-history-row {
  grid-template-columns: 1.15fr 0.7fr 1.5fr 1fr 1.2fr 0.9fr;
}

.fiat-activity-open {
  color: #d1aa67;
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
}

.fiat-activity-open:hover {
  text-decoration: underline;
}

.fiat-activity-empty-links {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px 16px;
  margin-top: 16px;
}

.fiat-activity-empty-links a {
  color: #d1aa67;
  font-weight: 600;
  text-decoration: none;
}

.fiat-activity-list .df-deposit-history-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.so-page .fiat-hold-banner {
  margin: 0 0 20px;
}

body.light_theme .fiat-activity-action {
  background: #fff;
  color: #0b0e11;
  border-color: rgba(209, 170, 103, 0.55);
}

body.light_theme .fiat-activity-action:hover {
  color: #0b0e11;
}

body.light_theme .fiat-activity-chip {
  color: #0b0e11;
}

@media (max-width: 767px) {
  .fiat-activity-actions {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/ui/Pages/FiatActivityPage/fiatActivity.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,kCAAkC;EAClC,cAAc;EACd,qBAAqB;EACrB,uDAAuD;AACzD;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;EAC3C,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,yDAAyD;AAC3D;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".fiat-activity-hero {\n  min-height: auto;\n  padding: 64px 0 40px;\n}\n\n.fiat-activity-actions {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n  margin-top: 28px;\n  max-width: 560px;\n}\n\n.fiat-activity-action {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 16px 18px;\n  border-radius: 12px;\n  border: 1px solid rgba(209, 170, 103, 0.35);\n  background: rgba(20, 24, 31, 0.55);\n  color: #eaecef;\n  text-decoration: none;\n  transition: border-color 0.2s ease, transform 0.2s ease;\n}\n\n.fiat-activity-action:hover {\n  border-color: #d1aa67;\n  transform: translateY(-2px);\n  color: #eaecef;\n}\n\n.fiat-activity-action-label {\n  font-weight: 600;\n  font-size: 15px;\n}\n\n.fiat-activity-action-hint {\n  font-size: 12px;\n  color: #84888c;\n}\n\n.fiat-activity-chip {\n  appearance: none;\n  border: 1px solid rgba(148, 163, 184, 0.35);\n  background: transparent;\n  color: #eaecef;\n  border-radius: 999px;\n  padding: 6px 14px;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.fiat-activity-chip.is-active {\n  border-color: #d1aa67;\n  color: #d1aa67;\n}\n\n.fiat-activity-desktop .df-deposit-history-head,\n.fiat-activity-desktop .df-deposit-history-row {\n  grid-template-columns: 1.15fr 0.7fr 1.5fr 1fr 1.2fr 0.9fr;\n}\n\n.fiat-activity-open {\n  color: #d1aa67;\n  font-size: 13px;\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.fiat-activity-open:hover {\n  text-decoration: underline;\n}\n\n.fiat-activity-empty-links {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 12px 16px;\n  margin-top: 16px;\n}\n\n.fiat-activity-empty-links a {\n  color: #d1aa67;\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.fiat-activity-list .df-deposit-history-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n}\n\n.so-page .fiat-hold-banner {\n  margin: 0 0 20px;\n}\n\nbody.light_theme .fiat-activity-action {\n  background: #fff;\n  color: #0b0e11;\n  border-color: rgba(209, 170, 103, 0.55);\n}\n\nbody.light_theme .fiat-activity-action:hover {\n  color: #0b0e11;\n}\n\nbody.light_theme .fiat-activity-chip {\n  color: #0b0e11;\n}\n\n@media (max-width: 767px) {\n  .fiat-activity-actions {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
